module.exports = __webpack_public_path__ + "img/adopciones3.593d77dc.jpg";